export const PROJECTS_ROUTE = {
  key: 'LEARN_PROJECTS_TESTS',
  path: '/projects/',
};

export const ENROLLMENTS_DEGREES_ROUTE = {
  key: 'LEARN_DEGREES',
  path: '/microdegree/',
};

export const ENROLLMENTS_COURSES_ROUTE = {
  key: 'LEARN_ENROLLED_COURSES',
  path: '/my-courses/enrolled/',
};
